import { Template } from "@/@types/flows/emailTemplates";
import { TemplateItem } from "@/@types/flows/emailTemplates/items";
import { ItemType } from "@/@types/flows/emailTemplates/items";

export abstract class TemplateHtmlBuilder {
  private static domParser = new DOMParser();

  static generateHtmlString(htmlString: string) {
    const parsedDocument = this.domParser.parseFromString(htmlString, "text/html");

    return parsedDocument.body.innerHTML;
  }

  static generateHtmlLinks(htmlString: string): string {
    if (htmlString) {
      htmlString = htmlString
        .replace(/ onclick="event\.preventDefault\(\);"/g, '')
        .replace(/ target="_blank"/g, '');

      htmlString = htmlString
        .replace(/<a\s+([^>]*\s)?href="([^"]*)"(?![^>]*target)([^>]*)>/g, (_, attr, href, rest) => {
        if (href == '#') {
          // Si el href es "#", agregamos el onclick y conservamos los otros atributos
          return `<a ${attr || ''}href="#" onclick="event.preventDefault();" ${rest}>`;
        } else {
          // Si tiene un href válido, agregamos el target="_blank" y conservamos los otros atributos
          return `<a ${attr || ''}href="${href}" target="_blank" ${rest}>`;
        }
      });
    }
    return htmlString;
  }

  static inlineCssStyles(htmlContent: string): string {
    if (!htmlContent) return htmlContent;
    try {
      const doc = this.domParser.parseFromString(htmlContent, "text/html");
      const styleSheets = Array.from(doc.styleSheets);

      styleSheets.forEach((sheet) => {
        try {
          const rules = Array.from(sheet.cssRules || []);
          rules.forEach((rule) => {
            if (rule instanceof CSSStyleRule && rule.selectorText) {
              try {
                const elements = doc.querySelectorAll(rule.selectorText);
                elements.forEach((el) => {
                  const existingStyle = el.getAttribute("style") || "";
                  const ruleStyle = rule.style.cssText;
                  if (ruleStyle) {
                    const newStyle = existingStyle
                      ? `${ruleStyle} ${existingStyle}`
                      : ruleStyle;
                    el.setAttribute("style", newStyle);
                  }
                });
              } catch (e) {
                // Ignore unsupported selectors in querySelectorAll
              }
            }
          });
        } catch (e) {
          // Ignore invalid stylesheets
        }
      });

      return doc.body ? doc.body.innerHTML : htmlContent;
    } catch (error) {
      console.error("Error inlining CSS styles:", error);
      return htmlContent;
    }
  }

  static generateHtmlTemplate(template: Template, items: TemplateItem[]) {   
    //Estilos para item html
    let styles: string[] = [];
    if(items?.[0]?.type == ItemType.Html) {
      const styleRegex = /<style\b[^>]*>([\s\S]*?)<\/style>/gi;
      styles = items?.[0]?.content.match(styleRegex) || [];
    }
    const stylesString = styles?.length > 0 ? styles?.join('') : '';
    const injectBodyIntoTemplateHtml = (bodyHtmlString: string) => `
    <!DOCTYPE html>
    <html lang="es">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>${template.name}</title>
        <meta name="description" content="${template.description}">
        ${stylesString}
      </head>
      <body style="margin: 0; padding: 0; box-sizing: border-box; font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; width: 100% !important;">
        <table role="presentation" width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 100%;">
          <tr>
            <td align="center">
              <table role="presentation" width="100%" border="0" cellspacing="0" cellpadding="0" style="max-width: 700px; width: 100%; margin: 0 auto;">
                <tr>
                  <td align="center">
                    ${bodyHtmlString}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </body>
    </html>
    `;

    const bodyHtml = items.map((i) => {
      if (i.type === ItemType.Html) {
        const fullSource = (i as any).content || i.htmlString || "";
        return this.inlineCssStyles(fullSource);
      }
      return i.htmlString;
    }).join("\n");
    return injectBodyIntoTemplateHtml(bodyHtml);
  }
}
